import colors from './colors';

const defaultNavigationOptions = {
  headerBackTitleVisible: false,
  headerTintColor: colors.chokuRed,
  headerTitleStyle: {color: colors.chokuBlack},
  headerStyle: {borderBottomColor: colors.chokuRed, borderBottomWidth: 4},
};

export default {
  defaultNavigationOptions,
};
